import React, { useState, useRef, useEffect } from "react";

const TeamOverviewTabs = ({ tabs, activeTab, onTabChange }) => {
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
  const tabsRef = useRef({});

  useEffect(() => {
    const activeTabEl = tabsRef.current[activeTab];
    if (activeTabEl) {
      setIndicatorStyle({
        left: activeTabEl.offsetLeft,
        width: activeTabEl.offsetWidth,
      });
    }
  }, [activeTab]);

  return (
    // Scrolls sideways on narrow screens instead of wrapping or clipping.
    <div
      className="overflow-x-auto border-b border-[#F3F4F6]"
      style={{ scrollbarWidth: "none" }}
    >
      <div className="relative flex w-max min-w-full">
        {/* Sliding indicator */}
        <div
          className="absolute bottom-0 h-0.5 bg-[#E07A3A] transition-all duration-300 ease-out"
          style={{
            left: indicatorStyle.left,
            width: indicatorStyle.width,
          }}
        />
        {tabs.map((tab) => (
          <button
            key={tab.id}
            ref={(el) => (tabsRef.current[tab.id] = el)}
            onClick={() => onTabChange(tab.id)}
            className="relative whitespace-nowrap px-4 py-3.5 text-sm font-semibold transition-colors duration-200"
            style={{
              color: activeTab === tab.id ? "#E07A3A" : "#6B7280",
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TeamOverviewTabs;
